import styled from 'styled-components';

export const PriceLine = styled.line`
  stroke: var(--primary-color);
  stroke-width: 2;
`;
